<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    {{campaign.data}} {{ campaign.name }}
</h1>
<div mat-dialog-content>
    <p>{{campaign.description}}</p>

    <div *ngFor="let groupId of campaign.groupIds">
        {{groupId}}
    </div>

    <div class="emails-container">
        <div *ngFor="let email of campaign.emails" class="email-item">
                <div class="email">
                    {{email.email}}
                </div>
                <div class="status">
                    {{email.status}}
                </div>
        </div>
    </div>

</div>
